import { Component, ViewEncapsulation } from '@angular/core';

import { AvatarBaseDirective } from './avatar-base';

@Component({
    selector: 'st-avatar[medium]',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            *ngIf="shouldShowImage"
            width="24"
            height="24"
            [ngSrc]="imageUrl"
            (error)="onImageError()"
            (load)="imgLoaded()" />
        <div
            *ngIf="!shouldShowImage"
            class="st-avatar__initials">
            {{ initials }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarMediumComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[horizontal-medium]:not([medium])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            *ngIf="shouldShowImage"
            width="24"
            height="24"
            [ngSrc]="imageUrl"
            (error)="onImageError()"
            (load)="imgLoaded()" />
        <div
            *ngIf="!shouldShowImage"
            class="st-avatar__initials">
            {{ initials }}
        </div>
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarMediumHorizontalNameComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[vertical-big]:not([big])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            width="32"
            height="32"
            [ngSrc]="imageUrl" />
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarMediumVerticalNameComponent extends AvatarBaseDirective {}
